module.exports = __webpack_public_path__ + "img/PF.c329cbd4.png";